"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;
exports.initGlobalAnalyticEvents = initGlobalAnalyticEvents;
exports.initShoppingContextEvents = initShoppingContextEvents;
exports.pushShoppingContextData = pushShoppingContextData;
exports.resetInitFlag = resetInitFlag;
var AddBasketOfferEvent = _interopRequireWildcard(require("@ori-events/add-basket-offer"));
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var AnalyticsEvent = _interopRequireWildcard(require("@ori-events/analytics"));
var BambuserLiveShoppingEvent = _interopRequireWildcard(require("@ori-events/bambuser-live-shopping"));
var BannerClickEvent = _interopRequireWildcard(require("@ori-events/banner-click"));
var BannerDataLoadedEvent = _interopRequireWildcard(require("@ori-events/banner-data-loaded"));
var BasketUpdated = _interopRequireWildcard(require("@ori-events/basket-updated"));
var ClearBasketEvent = _interopRequireWildcard(require("@ori-events/clear-basket"));
var ContextDataEvent = _interopRequireWildcard(require("@ori-events/context-data"));
var DownloadFile = _interopRequireWildcard(require("@ori-events/download-file"));
var ExpressCheckoutButtonClickEvent = _interopRequireWildcard(require("@ori-events/express-checkout-button-click"));
var FollowUsItemClickEvent = _interopRequireWildcard(require("@ori-events/follow-us-item-click"));
var _handlePartialViewAnalytics = require("@ori-events/handle-partial-view-analytics");
var LinkClickEvent = _interopRequireWildcard(require("@ori-events/link-click"));
var NewsletterSubscribeEvent = _interopRequireWildcard(require("@ori-events/newsletter-subscribe"));
var OlapicClickedEvent = _interopRequireWildcard(require("@ori-events/olapic-popup-product-clicked"));
var OrderPlacedEvent = _interopRequireWildcard(require("@ori-events/order-placed"));
var PersonalProductListEvent = _interopRequireWildcard(require("@ori-events/personal-product-list"));
var ProductClickEvent = _interopRequireWildcard(require("@ori-events/product-click"));
var ProductDataLoadedEvent = _interopRequireWildcard(require("@ori-events/product-data-loaded"));
var RemoveBasketItemEvent = _interopRequireWildcard(require("@ori-events/remove-basket-item"));
var RequestShoppingContext = _interopRequireWildcard(require("@ori-events/request-shopping-context"));
var SearchSuggestionClickEvent = _interopRequireWildcard(require("@ori-events/search-suggestion-click"));
var ShareItemClickEvent = _interopRequireWildcard(require("@ori-events/share-item-click"));
var ShoppingContextLoaded = _interopRequireWildcard(require("@ori-events/shopping-context-loaded"));
var UpdateBasketItemEvent = _interopRequireWildcard(require("@ori-events/update-basket-item"));
var UpdateOfferItemEvent = _interopRequireWildcard(require("@ori-events/update-offer-item"));
var UserActionEvent = _interopRequireWildcard(require("@ori-events/user-action"));
var UserRegisteredEvent = _interopRequireWildcard(require("@ori-events/user-registered"));
var UserUpgradeRequested = _interopRequireWildcard(require("@ori-events/user-upgrade-requested"));
var VideoPlayEvent = _interopRequireWildcard(require("@ori-events/video-play"));
var VirtualPageEvent = _interopRequireWildcard(require("@ori-events/virtual-page"));
var _constants = require("./constants");
var _gtmAnalytics = require("./gtmAnalytics");
var _types = require("./types");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
let isInitialized = false;
const forwardEventMethods = [];
const forwardEventToChannels = event => forwardEventMethods.forEach(method => method(event));

// Add needed global analytics event names into this list.
const globalEventNames = [AddBasketOfferEvent.Name, AddToBasketEvent.Name, BambuserLiveShoppingEvent.Name, BannerClickEvent.Name, BannerDataLoadedEvent.Name, ClearBasketEvent.Name, ContextDataEvent.Name, DownloadFile.Name, ExpressCheckoutButtonClickEvent.Name, FollowUsItemClickEvent.Name, LinkClickEvent.Name, NewsletterSubscribeEvent.Name, OlapicClickedEvent.Name, OrderPlacedEvent.Name, PersonalProductListEvent.Name, ProductClickEvent.Name, ProductDataLoadedEvent.Name, RemoveBasketItemEvent.Name, SearchSuggestionClickEvent.Name, ShareItemClickEvent.Name, UpdateBasketItemEvent.Name, UpdateOfferItemEvent.Name, UserActionEvent.Name, UserRegisteredEvent.Name, VideoPlayEvent.Name, VirtualPageEvent.Name, UserUpgradeRequested.Name];

// Adds event listeners for the above mentioned custom events.
// The handler transforms particular CustomEvent to AnalyticsEvent and re-triggers it in global
// context, so that the analytics provider can finally catch it in one unified way.
function initGlobalAnalyticEvents() {
  globalEventNames.forEach(eventName => window.addEventListener(eventName, AnalyticsEvent.forwardAnalyticsEvent));
}
/** Global events needed for monitoring shopping context data. */
const shoppingContextEventNames = [BasketUpdated.Name, ShoppingContextLoaded.Name];

/** Indication that shopping context data was already received. */
let hasShoppingContextInfo = false;
function pushShoppingContextData(event) {
  // mark the shopping context data as loaded
  hasShoppingContextInfo = true;
  // create analytics event in same format as AnalyticsEvent.forwardAnalyticsEvent would return
  const {
    availableRewardShopPoints: points
  } = event.detail.shoppingBag;
  const rewardPoints = typeof points === 'number' ? points : null;
  const detail = {
    originalEventType: _types.ShoppingContextDataEvent,
    originalEventDetail: {
      rewardPoints
    }
  };
  const analyticsEvent = new CustomEvent(AnalyticsEvent.Name, {
    detail
  });
  // forward the event to defined analytics channels
  forwardEventToChannels(analyticsEvent);
}

/**
 * Connects listening to first incomming shopping context data event
 * (shopping-context-loaded or basket-updated). Once received, forwards
 * selected event data to dataLayer & disconnects both events.
 */
function initShoppingContextEvents() {
  const handler = event => {
    pushShoppingContextData(event);
    // disconnect events after 1st shopping context info was received
    shoppingContextEventNames.forEach(eventName => window.removeEventListener(eventName, handler));
  };
  shoppingContextEventNames.forEach(eventName => window.addEventListener(eventName, handler));
  // Only if the shopping context data wasn't loaded in a half second
  // due to events triggered by other components, trigger the request context event here.
  window.setTimeout(() => {
    if (!hasShoppingContextInfo) {
      window.dispatchEvent(new CustomEvent(RequestShoppingContext.Name));
    }
  }, 500);
}
function getDataFromElement(configElementId) {
  const dataElement = document.getElementById(configElementId);
  if (!dataElement?.innerHTML) {
    throw new TypeError("Analytics provider configuration wasn't set properly.");
  }
  const data = dataElement.innerHTML;
  return JSON.parse(data);
}

// Re-init data from partial view & send basic user identification events.
function handleAnalyticsEventsFromPartialView() {
  const model = getDataFromElement(_constants.PARTIAL_VIEW_CONFIG_ELEMENT_ID);
  (0, _gtmAnalytics.handleAnalyticsEventsFromPartialView)(model);
}

// Main initialization.
function init() {
  if (isInitialized) {
    return;
  }

  // So far, only GTM forward channel is included here. Later on, we might add
  // Baidu analytics for China, App Insights, etc. This should be rather dynamic,
  // based on configuration data.
  const model = getDataFromElement(_constants.CONFIG_ELEMENT_ID);
  (0, _gtmAnalytics.initGtm)(model);
  forwardEventMethods.push(_gtmAnalytics.forwardEvent);
  isInitialized = true;

  // Connect analytics events (only) here. We suppose that analytics event proxies
  // will do the transformation from original custom events where needed & send
  // the needed analytics events.
  window.addEventListener(AnalyticsEvent.Name, forwardEventToChannels);

  // Re-init data from partial view & send basic user identification events.
  window.addEventListener(_handlePartialViewAnalytics.HandlePartialViewAnalytics, handleAnalyticsEventsFromPartialView);

  // Connect particular event type listeners.
  initGlobalAnalyticEvents();
  initShoppingContextEvents();

  // Set ready flag in globals for other components with critical initialization timing.
  window.isAnalyticsProviderReady = true;
}

// This helper is used just for testing ATM.
function resetInitFlag() {
  isInitialized = false;
}
